import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ae82cd8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4ae82cd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae82cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae82cd8')) {
      api.createRecord('4ae82cd8', component.options)
    } else {
      api.reload('4ae82cd8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ae82cd8&scoped=true", function () {
      api.rerender('4ae82cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cockpit/index.vue"
export default component.exports